<template>
  <div class="page-table scrollable only-y">
    <div class="page-header no-table-box">
      <el-row class="hidden-sm-and-up pb-15">
          <h1>
            <v-svg class="voxo-aqua" sprite="phone-number" />
            Phone Numbers
          </h1>
      </el-row>
      <el-row class="hidden-xs-only pb-15">
        <el-col :span="16">
          <h1>
            <v-svg class="voxo-aqua" sprite="phone-number" />
            Phone Numbers
          </h1>
        </el-col>

        <el-col class="text-right" :span="8">
          <el-tag>
            <i class="el-icon-info" style="margin-right: 4px" />
            Total: {{ total | number }}
          </el-tag>
        </el-col>
      </el-row>
      <div class="flex pb-20">
        <div class="box">
          <el-input v-model="search" placeholder="Search" clearable />
          <el-button
            class="ml-10 hidden-xs-only"
            @click="doExport"
          >
            Export
          </el-button>
        </div>
        <div class="box right">
          <el-dropdown>
            <el-button>
              Add New
              <i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item @click.native="openCreate('phoneNumber')">
                <v-svg class="success-text" sprite="telephone-2" />
                Phone Number
              </el-dropdown-item>
              <el-dropdown-item @click.native="openCreate('tollFree')">
                <v-svg class="voxo-orange" sprite="fax-2" />
                Toll Free
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
      <div class="vxe-table-height card-base card-shadow--medium">
        <vxe-grid
          round
          border="inner"
          ref="xGrid"
          height="100%"
          auto-resize
          empty-text="No Data"
          show-overflow="tooltip"
          highlight-hover-row
          @cell-click="cellClicked"
          @cell-mouseenter="rowHover"
          @cell-mouseleave="rowLeave"
          :data="tableData"
          :scroll-y="{ enabled: true, gt: 50, oSize: 0 }"
          :loading="tableLoading"
          :columns="tableColumns"
        />
      </div>
    </div>

    <edit-form
      :editProcessing="editProcessing"
      :editVisible="editVisible"
      :currentRecord="currentRecord"
      :branchOptions="branchOptions"
      :recordingOptions="recordingOptions"
      :clearFields="clearFields"
      @cancelOperation="cancelEditOperation"
      @deleteRecord="deleteRecord"
      @updateNumber="updateNumber"
    />

    <create-phone-number
      v-if="numberType === 'phoneNumber'"
      :createProcessing="createProcessing"
      :createVisible="createVisible"
      :branchOptions="branchOptions"
      :clearFields="clearFields"
      @orderNumbers="orderNumbers"
      @cancelOperation="cancelCreateOperation"
    />

    <create-toll-free
      v-if="numberType === 'tollFree'"
      :createProcessing="createProcessing"
      :createVisible="createVisible"
      :branchOptions="branchOptions"
      :clearFields="clearFields"
      @orderTollFree="orderNumbers"
      @cancelOperation="cancelCreateOperation"
    />

    <el-dialog
      :visible="wireTapVisible"
      width="30%"
      :close-on-click-modal="false"
      :before-close="handleCloseWireTapModal"
      :modal="false"
    >
      <h2 class="form-section-header black-text">
        Wiretap extension {{`${this.numberFormatter(wireTapExt)}`}}
      </h2>
      <p class="black-text">
        Wiretap is a feature that allows you to view a live packet capture of the respective phone number.
      </p>
      <p class="black-text">
        You are about to be redirected to a live packet capture of this phone number's activity.
        This session will die after 30 minutes. All of the keybindings can be found
        <a href="https://github.com/irontec/sngrep/wiki/Configuration#keybindings" target="_blank">here.</a>
      </p>
      <p class="black-text">
        Also, if you'd like to save pcap(s) and have them emailed automatically, set the filename to an email address.
      </p>
      <el-button
        @click="startWireTap"
      >
        Start
      </el-button>
    </el-dialog>

  </div>
</template>

<script>
import { mapActions } from "vuex";
import feathersClient from "../../../feathers/feathers-client";
import debounce from "lodash/debounce";
import { globalEventBus } from "@/globalEventBus";

import EditForm from "./components/editForm.vue";
import CreatePhoneNumber from "./components/createPhoneNumber.vue";
import CreateTollFree from "./components/createTollFree.vue";
import DadsSelect from '@/components/select';
import {ExportToCsv} from "export-to-csv";
import {phoneNumberFormatter} from "@/globals/globals";

export default {
  name: "DidsTable",

  components: {
    EditForm,
    CreatePhoneNumber,
    CreateTollFree,
    DadsSelect
  },

  data() {
    return {
      numberType: "",
      wireTapVisible: false,
      wireTapExt: null,
      search: "",
      total: 0,
      branchOptions: [],
      allDids: [],
      visibleActionsId: "",
      modalModelId: "",
      currentRecord: null,
      editVisible: false,
      createVisible: false,
      tableData: [],
      createProcessing: false,
      editProcessing: false,
      recordingOptions: [
        {label: "Yes", value: "yeschange"},
        {label: "No", value: "no"},
        {label: "No, but allow start/stop", value: 'nochange'}
      ],
      tableLoading: false,
      didChannel: null,
      clearFields: false,
      createForm: {
        state: "",
        rateCenter: "",
        area: "",
        numbers: [],
        branchId: ""
      },
      tableColumns: [
        {
          field: "sprite",
          title: "",
          width: 50,
          slots: {
            default: ({ row }) => {
              return [
                <div class="voxo-square-icon voxo-bg-btn">
                  <v-svg class="voxo-aqua" sprite="phone-number" />
                </div>
              ];
            }
          }
        },
        {
          field: "number",
          title: "Number",
          minWidth: 150,
          sortable: true,
          slots: {
            default: ({ row }) => {
              return [
                <span class="first-table-column">
                  {this.numberFormatter(row.number)}
                </span>
              ];
            }
          }
        },
        {
          field: 'diCommentName',
          title: 'Description',
          minWidth: 200,
          showOverflow: true,
          sortable: true
        },
        {
          field: "namePrefix",
          title: "Prefix",
          minWidth: 150,
          sortable: true
        },
        {
          field: "branch",
          title: "Branch",
          sortable: true,
          minWidth: 200,
          slots: {
            default: ({row}) => {
              return [
                <span>{this.getBranchName(row.branchId)}</span>
              ]
            }
          }
        },
        {
          field: "useStatus",
          title: "Status",
          sortable: true,
          minWidth: 100,
          slots: {
            default: ({row}) => {
              return [
                <span>{row.useStatus === 'Unavailable' ? 'In Use' : 'Not In Use'}</span>
              ]
            }
          }
        },
        {
          field: 'isFax',
          title: 'Use',
          minWidth: 75,
          sortable: true,
          sortBy: row => row.isFax ? 'Fax' : 'Voice',
          slots: {
            default: ({row}) => {
              return [
                <span>{row.isFax ? 'Fax' : 'Voice'}</span>
              ]
            }
          }
        },
        {
          field: "actions",
          title: "",
          minWidth: "150",
          showOverflow: false,
          slots: {
            default: ({ row }) => {
              return [
                <div v-show={row.id === this.visibleActionsId}>
                  <el-button
                    id={"edit-" + row.id}
                    icon="el-icon-edit"
                    onClick={() => this.getNumberProfile(row.id)}
                    class="table-action-button icon-blue"
                  />
                  <el-button
                    id={"delete-" + row.id}
                    icon="el-icon-delete"
                    onClick={() => this.deleteRecord(row.id)}
                    class="table-action-button icon-red"
                  />
                  <el-tooltip placement="top" content="Wiretap">
                    <el-button
                      id={'wire-tap-' + row.id}
                      icon="el-icon-sort"
                      class="table-action-button icon-green"
                      onClick={() => this.openWireTapModal(row.number)}
                    />
                  </el-tooltip>
                </div>
              ];
            }
          }
        }
      ]
    };
  },
  computed: {
    selectedTenant() {
      return this.$store.state.selectedTenant;
    },
    user() {
      return this.$store.state.auth.user;
    }
  },
  watch: {
    search: debounce(function() {
      this.searchNumbers();
    }, 500),
    user() {
      this.queryBranches();
      this.getDidsList();
      if (!this.didChannel) {
        this.joinSocketChannel();
      }
    },
    selectedTenant() {
      this.queryBranches();
      this.getDidsList();
      feathersClient
        .service("channel-memberships")
        .remove(null, { query: { channelName: this.didChannel } });
      this.joinSocketChannel();
    }
  },
  methods: {
    ...mapActions("dids", {
      createNumbers: "create",
      removeNumber: "remove",
      patchNumber: "patch"
    }),

    openCreate(type) {
      this.numberType = type;
      this.clearFields = false;
      this.createVisible = true;
    },

    doExport(){
      const data = [...this.tableData];
      if(data.length){

        const writeData = data.map(item => ({
          number: item.number,
          description: item.diCommentName,
          prefix: item.namePrefix,
          branch: item.branch,
          status: item.useStatus,
          use: item.isFax ? 'Fax' : 'Voice'
        }));

        const options = {
          filename: 'phone_numbers',
          showLabels: true,
          headers: ['Number', 'Description', 'Prefix', 'Branch', 'Status', 'Use']
        }

        const csvExporter = new ExportToCsv(options);
        csvExporter.generateCsv(writeData);
      }
    },

    cellClicked(data) {
      if (data.column.property !== "actions") {
        this.getNumberProfile(data.row.id);
      }
    },

    rowHover(data) {
      this.visibleActionsId = data.row.id;
    },

    rowLeave() {
      this.visibleActionsId = "";
    },

    queryBranches() {
      feathersClient
        .service("branches")
        .find({
          query: {
            tenantId: this.selectedTenant.id
          }
        })
        .then(res => {
          this.branchOptions = res;
        }).catch( () => {
          this.branchOptions = [];
      });
    },

    numberFormatter(number) {
      return phoneNumberFormatter(number);
    },

    searchNumbers() {
      this.tableLoading = true;
      this.tableData = this.search.length
        ? this.allDids.filter(
            ({ number, useStatus, branch, diCommentName }) =>
              number.includes(this.search) ||
              diCommentName.toLowerCase().includes(this.search.toLowerCase()) ||
              branch.toLowerCase().includes(this.search.toLowerCase())
          )
        : [...this.allDids];
      this.tableLoading = false;
      this.total = this.tableData.length;
    },

    orderNumbers(orderBody) {
      this.$confirm("Process Number Order?", "Warning", {
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        type: "warning"
      })
        .then(() => {
          this.createProcessing = true;
          this.createNumbers(orderBody)
            .then(res => {
              this.$notify({
                title: "Success",
                message: "Order Successful!",
                type: "success"
              });
              if (this.numberType === "phoneNumber") {
                this.addNewBranch(orderBody.branchId);
              }
              this.createProcessing = false;
              let numbersCreated = [];
              res.forEach(d => {
                numbersCreated.push(d.number);
              });
              let numbersIgnored = [];
              orderBody.numbers.forEach(number => {
                if (!numbersCreated.includes(number)) {
                  numbersIgnored.push(number);
                }
              });
              if (numbersIgnored.length) {
                this.$alert(
                  numbersIgnored + ": Not Available For Order",
                  "Order Alert",
                  {
                    confirmButtonText: "OK"
                  }
                );
              }
              this.clearFields = true;
              this.createVisible = false;
            })
            .catch(error => {
              this.createProcessing = false;
              if (error.name === "BadRequest") {
                this.$notify({
                  title: "The order couldn't be complete.",
                  message: error.message,
                  type: "error"
                });
                return;
              }
              if (error.hasOwnProperty("errors")) {
                this.$notify({
                  title: error.message,
                  message: error.errors[Object.keys(error.errors)[0]],
                  type: "error"
                });
              } else {
                this.$notify({
                  title: error.name,
                  message: error.message,
                  type: "error"
                });
              }
            });
        })
        .catch(() => true);
    },

    //edit operations
    async getNumberProfile(id) {
      this.clearFields = false;
      this.editVisible = true;
      this.modalModelId = id;
      this.currentRecord = await feathersClient.service("dids").get(id);
    },

    updateNumber(editBody) {
      //confirm complete close modal
      this.$confirm("Update phone number details?", "Warning", {
        confirmButtonText: "Update",
        cancelButtonText: "Cancel"
      })
        .then(() => {
          this.editProcessing = true;
          //set up form data to post.
          let data = { ...editBody, tenantId: this.selectedTenant.id };

          if (!data.branchId) {
            this.$notify({
              title: `Branch is required!`,
              message: "Please select a branch and try again.",
              type: "error",
            });
            this.editProcessing = false;
            return;
          }

          //patch existing Did record
          this.patchNumber([this.modalModelId, data])
            .then(res => {
              this.$notify({
                title: "Success",
                message:
                  this.numberFormatter(res.number) + " has been updated!",
                type: "success"
              });
              this.addNewBranch(data.branchId);
              this.editVisible = false;
              this.editProcessing = false;
              this.clearFields = true;
            })
            .catch(error => {
              if (error.hasOwnProperty("errors")) {
                this.$notify({
                  title: error.message,
                  message: error.errors[Object.keys(error.errors)[0]],
                  type: "error"
                });
              } else {
                this.$notify({
                  title: error.name,
                  message: error.message,
                  type: "error"
                });
              }
              this.editProcessing = false;
            });
        })
        .catch(() => true);
    },

    //delete operations
    async deleteRecord(id) {
      if (!this.editVisible) {
        this.deleteProcessing = true;
      }
      this.editProcessing = true;

      //set a delay to ensure that the destinations have had time to return asynchronously
      let message = "";
      const DidRecord = await feathersClient.service("dids").get(id);

      if (DidRecord.useStatus === "Unavailable") {
        message =
          "Are You Sure? This number is assigned to something in your account." +
          " Once you delete this number, it will not be able to be retrieved again.";
      } else {
        message = "Permanently Delete This Number?";
      }

      this.deleteProcessing = false;
      this.$confirm(message, {
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        type: "warning"
      })
        .then(() => {
          if (!this.editVisible) {
            this.deleteProcessing = true;
          }
          this.editProcessing = true;
          this.removeNumber(id)
            .then(() => {
              this.$notify({
                title: "Success",
                message: "Phone number successfully removed!",
                type: "success"
              });
              this.deleteProcessing = false;
              this.editProcessing = false;
              this.editVisible = false;
            })
            .catch(error => {
              this.$notify({
                title: error.name,
                message: error.message,
                type: "error"
              });
              this.deleteProcessing = false;
              this.editProcessing = false;
            });
        })
        .catch(() => true);
    },

    addNewBranch(branchId) {
      if (typeof branchId === "string") {
        this.queryBranches();
      }
    },

    cancelCreateOperation() {
      this.createVisible = false;
      this.clearFields = true;
    },
    cancelEditOperation() {
      this.editVisible = false;
      this.clearFields = true;
    },

    clearFormFields(form) {
      Object.keys(form).forEach(key => {
        form[key] = typeof form[key] === typeof [] ? [] : "";
      });
    },

    getDidsList() {
      this.tableLoading = true;
      feathersClient
        .service("dids")
        .find({
          query: {
            tenantId: this.selectedTenant.id,
            allowEmergency: ""
          }
        })
        .then(res => {
          this.allDids = [...res];
          this.tableData = [...res];
          this.total = res.length;
          this.tableLoading = false;
        })
        .catch(e => {
          this.allDids = [];
          this.tableData = [];
          this.total = 0;
          this.tableLoading = false;
        });
    },

    joinSocketChannel() {
      const channelService = feathersClient.service("channel-memberships");
      const data = {
        roomType: "admins",
        tenantId: this.selectedTenant.id
      };
      channelService.create(data).then(res => {
        this.didChannel = `${data.roomType}/${data.tenantId}`;
      });
    },

    removeListeners() {
      feathersClient.service("dids").removeListener("patched");
      feathersClient.service("dids").removeListener("created");
      feathersClient.service("dids").removeListener("removed");
      globalEventBus.$off("appReconnected");
    },

    openWireTapModal(number){
      console.log('opening wire tap modal for number', number);
      this.wireTapExt = number;
      this.wireTapVisible = true;
    },

    startWireTap(){

      console.log('launching wire tap', this.wireTapExt);

      feathersClient.service('nats-actions-handler').create({
        reqType: 'startWireTap',
        expression: `(${this.wireTapExt})`
      }).then(res => {

        console.log(res);

        if(res === 'Request Failed'){
          this.$message({
            message: 'Something went wrong! Try again.',
            duration: 1000
          });
        } else{
          const link = document.createElement('a');
          link.href = res.url;
          link.target = '_blank';
          link.click();
          link.remove();
          this.handleCloseWireTapModal();
        }

      }).catch( () => {
        this.$message({
          message: 'Something went wrong! Try again.',
          duration: 1000
        });this.$message('Something went wrong! Try again.')
      });
    },

    handleCloseWireTapModal(){
      this.wireTapExt = null;
      this.wireTapVisible = false;
    },

    getBranchName(id){
      const branch = this.branchOptions.find(item => item.id === id);
      return branch ? branch.name : '';
    }
  },
  beforeMount() {
    //check context of route so we can show a modal if appropriate
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has("context")) {
      const context = urlParams.get("context");
      if (context === "create") {
        this.createVisible = true;
      }
    }
  },
  created() {
    this.getDidsList();
    this.queryBranches();
    this.joinSocketChannel();

    //event listeners
    //monitor socket connection and reconnect to channel
    globalEventBus.$on("appReconnected", () => {
      this.joinSocketChannel();
    });

    //record was edited
    feathersClient.service("dids").on("patched", data => {
      const updateIndex = this.tableData.findIndex(item => item.id === data.id);
      const updateAllIndex = this.allDids.findIndex(
        item => item.id === data.id
      );
      if (updateIndex >= 0) {
        this.tableData.splice(updateIndex, 1, data);
      }
      if (updateAllIndex >= 0) {
        this.allDids.splice(updateAllIndex, 1, data);
      }
    });

    //record was created
    feathersClient.service("dids").on("created", data => {
      this.tableData.push(data);
      this.allDids.push(data);
    });

    //record was deleted
    feathersClient.service("dids").on("removed", data => {
      const indexToRemove = this.tableData.findIndex(
        item => item.id === data.id
      );
      const indexAllToRemove = this.allDids.findIndex(
        item => item.id === data.id
      );
      if (indexToRemove >= 0) {
        this.tableData.splice(indexToRemove, 1);
      }
      if (indexAllToRemove >= 0) {
        this.allDids.splice(indexAllToRemove, 1);
      }
    });
  },

  beforeDestroy() {
    feathersClient
      .service("channel-memberships")
      .remove(null, { query: { channelName: this.didChannel } });
    this.removeListeners();
  },
  filters: {
    number(value) {
      return !isNaN(value)
        ? new Intl.NumberFormat("en-US").format(value)
        : value;
    }
  }
};
</script>
